import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import aiIcon from '../images/TD AI Icon 2 Color.png';
import { useSelector } from 'react-redux';

function SiteMenu(props) {
  const [showInbox, setShowInbox] = useState(false);
  const [showSysConfig, setShowSysConfig] = useState(true);

  const userInfo = useSelector(state => state.userInfo.value);

  useEffect(() => {

  }, [userInfo]);


    function toBoolean(value) {
      if (typeof value === 'string') {
        return value.toLowerCase() === 'true';
      }
      return false;
    }

  return (
    <div>
      <Link to='/Inbox' style={{ textDecoration: 'none', color: 'white' }}>
        <div
          // onClick={() => {
          //   setShowInbox(!showInbox);
          //   setShowSysConfig(false);
          //   console.log(props);
          //}}
          className='navHeader'
          onClick={props.onToggle}
        >
          <span style={{ color: '#48B048' }}>
            <i className='fa-solid fa-inbox' />
          </span>{' '}
          Inbox
        </div>
      </Link>
      {showInbox && (
        <div >
          <div className='navSubHeader'>
            <span style={{ color: '#48B048' }}>
              <i className='fa-solid fa-inbox' />
            </span>{' '}
            View Inbox
          </div>
          <div className='navSubHeader'>
            <span style={{ color: '#DADADA' }}>
              <i className='fa-solid fa-list' />
            </span>{' '}
            My Queues <span className='badge bg-primary'>36</span>
          </div>
          <div className='navSubHeader'>
            <span style={{ color: '#DADADA' }}>
              <i className='fa-solid fa-filter' />
            </span>{' '}
            My Filters
          </div>
          <div className='navSubHeader'>
            <span style={{ color: '#E542D6' }}>
              <i className='fa-regular fa-file' />
            </span>{' '}
            Image Review <span className='badge bg-primary'>4</span>
          </div>
        </div>
      )}

      {toBoolean(userInfo.userSettings.betaActiveDocuments) === true && (
        <Link
          to='/BetaActiveDocuments'
          style={{ textDecoration: 'none', color: 'white' }}
        >
          <div className='navHeader' onClick={props.onToggle}>
            <span style={{ color: '#E2D45B' }}>
              <i className='fa-solid fa-cubes' />
            </span>{' '}
            Active Documents
          </div>
        </Link>
      )}
      {toBoolean(userInfo.userSettings.betaActiveDocuments) !== true && (
        <Link
          to='/ActiveDocuments'
          style={{ textDecoration: 'none', color: 'white' }}
        >
          <div className='navHeader' onClick={props.onToggle}>
            <span style={{ color: '#E2D45B' }}>
              <i className='fa-solid fa-cubes' />
            </span>{' '}
            Active Documents
          </div>
        </Link>
      )}

      <div className='ms-2'>{/*<ActiveDocuments /> */}</div>
      <Link to='/Search' style={{ textDecoration: 'none', color: 'white' }}>
        <div className='navHeader' onClick={props.onToggle}>
          <span style={{ color: '#4BB5CF' }}>
            <i className='fa-solid fa-search' />
          </span>{' '}
          Advanced Search
        </div>
      </Link>

      {/*{props.canImageReview && (
        <Link
          to='/ImageReview'
          style={{ textDecoration: 'none', color: 'white' }}
        >
          <div className='navHeader' onClick={props.onToggle}>
            <span style={{ color: '#AE4BCF' }}>
              <i className='fa-solid fa-file-image' />
            </span>{' '}
            Image Review
          </div>
        </Link>
      )}*/}
      {props.licenseLevel >= 3 && (
        <Link
          to='/TemplateEditor'
          style={{ textDecoration: 'none', color: 'white' }}
        >
          <div className='navHeader' onClick={props.onToggle}>
            <span style={{ color: '#79EA6E' }}>
              <i className='fa-solid fa-puzzle-piece' />
            </span>{' '}
            Templates
          </div>
        </Link>
      )}
      {props.licenseLevel >= 3 && (
        <Link
          to='/Admin/Defaults'
          style={{ textDecoration: 'none', color: 'white' }}
        >
          <div className='navHeader' onClick={props.onToggle}>
            <span style={{ color: '#4EE8E8' }}>
              <i className='fa-solid fa-pen-clip' />
            </span>{' '}
            Defaults
          </div>
        </Link>
      )}

      {/* {props.trinFormsUrl !== '' && ( */}
        <div className='navHeader' onClick={props.onRouteToTrinForms}>
          <a
            id='trinFormsLink'
            style={{ display: 'none' }}
            href={props.trinFormsUrl}
          ></a>
          <span style={{ color: '#E2D45B' }}>
            <i className='fa-duotone fa-regular fa-pen-to-square' style={{"--fa-primary-color": "#16c0bd", "faSecondaryColor": "#14807e"}}></i>
          </span>{' '}
          Go To TrinForms
        </div>
      {/* )} */}

      {showSysConfig && props.licenseLevel >= 4 && (
        <div >
          <div className='navLabel'>Business Process</div>
          <Link
            to='/Admin/BusinessProcess'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#8090FF' }}>
                <i className='fa-solid fa-building' />
              </span>{' '}
              Business Processes
            </div>
          </Link>
          <Link
            to='/Admin/FormTypes'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#8090FF' }}>
                <i className='fa-solid fa-file-invoice' />
              </span>{' '}
              Form Types
            </div>
          </Link>
          <Link
            to='/Admin/OrgUnits'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#8090FF' }}>
                <i className='fa-solid fa-th-list' />
              </span>{' '}
              Organizational Units
            </div>
          </Link>
          <Link
            to='/Admin/Workflows'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#8090FF' }}>
                <i className='fa-solid fa-sitemap' />
              </span>{' '}
              Workflows
            </div>
          </Link>

          <div className='navLabel'>Integrations</div>
          <Link
            to='/Admin/Connection'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#6CE84E' }}>
                <i className='fa-solid fa-database' />
              </span>{' '}
              Connections
            </div>
          </Link>
          <Link
            to='/Admin/Modules'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#6CE84E' }}>
                <i className='fa-solid fa-box' />
              </span>{' '}
              Modules
            </div>
          </Link>


          <Link
            to='/Admin/Schedules'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#6CE84E' }}>
                <i className='fa-solid fa-calendar-check' />
              </span>{' '}
              Schedule
            </div>
          </Link>
          <Link
            to='/Admin/Secret'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#6CE84E' }}>
                <i className='fa-solid fa-key' />
              </span>{' '}
              Secrets
            </div>
          </Link>
          <div className='navLabel'>User Management</div>
          <Link
            to='/Admin/LoginSettings'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#E8C54E' }}>
                <i className='fa-solid fa-sign-in-alt' />
              </span>{' '}
              AD/OAUTH
            </div>
          </Link>
          <Link
            to='/Admin/Credential'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#E8C54E' }}>
                <i className='fa-solid fa-id-badge' />
              </span>{' '}
              Credential Manager
            </div>
          </Link>
          <Link
            to='/Admin/LicenseAllocation'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#E8C54E' }}>
                <i className='fa-solid fa-id-card' />
              </span>{' '}
              License Allocation
            </div>
          </Link>
          <Link
            to='/Admin/Roles'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#E8C54E' }}>
                <i className='fa-solid fa-user-friends' />
              </span>{' '}
              Roles
            </div>
          </Link>
          <Link
            to='/Admin/Users'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#E8C54E' }}>
                <i className='fa-solid fa-user' />
              </span>{' '}
              Users
            </div>
          </Link>

          <div className='navLabel'>Intake</div>

          <Link
            to='/Admin/Readers'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#4EE8E8' }}>
              <i className="fa-regular fa-microchip-ai"></i>
              </span>{' '}
              AI OCR
              <span>
                <img src={aiIcon} className='aiMenuIcon' alt='aiIcon' />
              </span>
            </div>
          </Link>

          <Link
            to='/Admin/Defaults'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#4EE8E8' }}>
                <i className='fa-solid fa-pen-clip' />
              </span>{' '}
              Defaults
            </div>
          </Link>
          <Link
            to='/Admin/Directories'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#4EE8E8' }}>
                <i className='fa-solid fa-folder-open' />
              </span>{' '}
              Directories
            </div>
          </Link>
          <Link
            to='/Admin/InboundAutomationHome'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#4EE8E8' }}>
                <i className='fa-regular fa-envelope-open' />
              </span>{' '}
              InboundAutomation
            </div>
          </Link>
          <Link
            to='/Admin/IntakeSettings'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#4EE8E8' }}>
                <i className='fa-solid fa-cog' />
              </span>{' '}
              Intake Settings
            </div>
          </Link>
          {/* ML OCR Commented out */}
          {/* <Link
            to='/Admin/AIOCRSettings'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#4EE8E8' }}>
                <i className='fa-solid fa-brain-circuit' />
              </span>{' '}
              AI OCR Settings
            </div>
          </Link> */}
          <Link
            to='/Admin/IntakeStrategies'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#4EE8E8' }}>
                <i className='fa-regular fa-file-import' />
              </span>{' '}
              Intake Strategies
            </div>
          </Link>
          <Link
            to='/Admin/UploadTracker'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#4EE8E8' }}>
                <i className='fa-solid fa-upload' />
              </span>{' '}
              Upload Tracker
            </div>
          </Link>

          <div className='navLabel'>Configuration</div>

          <Link
            to='/Admin/TableEditorView/ClientIntegrationConfigSettings'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#BE4EE8' }}>
                <i className='fa-solid fa-table' />
              </span>{' '}
              Client Integration Config
            </div>
          </Link>
          <Link
            to='/Admin/Companion'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#BE4EE8' }}>
                <i className='fa-solid fa-table' />
              </span>{' '}
              Companion Tables
            </div>
          </Link>
          <Link
            to='/Admin/Archive'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#BE4EE8' }}>
                <i className='fa-solid fa-archive' />
              </span>{' '}
              Document Storage
            </div>
          </Link>
          <Link
            to='/Admin/License'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#BE4EE8' }}>
                <i className='fa-solid fa-file-signature' />
              </span>{' '}
              License
            </div>
          </Link>
          <Link
            to='/Admin/Logs'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#BE4EE8' }}>
                <i className='fa-regular fa-list-alt' />
              </span>{' '}
              Logs
            </div>
          </Link>
          <Link
            to='/Admin/Mailbox'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#BE4EE8' }}>
                <i className='fa-solid fa-envelope-square' />
              </span>{' '}
              Mailboxes
            </div>
          </Link>
          <Link
            to='/Admin/SystemSettings'
            style={{ textDecoration: 'none', color: 'white' }}
          >
            <div className='navSubHeader' onClick={props.onToggle}>
              <span style={{ color: '#BE4EE8' }}>
                <i className='fa-solid fa-cog' />
              </span>{' '}
              System Settings
            </div>
          </Link>

        </div>
      )}
    </div>
  );
}
export default SiteMenu;
